import React, { useState, useEffect } from 'react';
import '../styles/ArtsCategory.css';
import pic1 from "../assets/geography (1).png";
import pic2 from "../assets/political-science (1).png";
import pic3 from "../assets/economic (1).png";
import pic4 from "../assets/hindi (1).png";
import pic5 from "../assets/hindi (1).png";
import pic6 from "../assets/sanskrit (1).png";
import pic7 from "../assets/sociology (1).png";
import pic8 from "../assets/history (1).png";
import pic9 from "../assets/math.png";
import pic10 from "../assets/comp.png";
import pic11 from "../assets/hindi (1).png";
import pic12 from "../sciencelabs/computer (2).webp"
import pic13 from "../sciencelabs/geography (2).webp"

const ArtsCategory = () => {
  const [currentImageSlide, setCurrentImageSlide] = useState(0);
  const [autoPlay, setAutoPlay] = useState(true);

  const sliderImages = [
    pic12,
    pic13,
  ];

  const subjects = [
    {
      id: 1,
      name: 'Geography',
      description: 'Explore the Earth\'s physical and human landscapes. Study landforms, climate zones, ecosystems, and the intricate relationships between people and their environment.',
      icon: pic1,
    },
    {
      id: 2,
      name: 'Political Science',
      description: 'Understand the structures and processes of government, politics, and public policy. Analyze constitutions, political systems, and the dynamics of power and governance.',
      icon: pic2,
    },
    {
      id: 3,
      name: 'Economics',
      description: 'Master the principles of production, distribution, and consumption. Study microeconomics, macroeconomics, and how societies manage resources and create wealth.',
      icon: pic3,
    },
    {
      id: 4,
      name: 'Hindi Literature',
      description: 'Immerse yourself in the rich tradition of Hindi literature. Read classic and contemporary works that reflect Indian culture, philosophy, and human experience.',
      icon: pic4,
    },
    {
      id: 5,
      name: 'English Literature',
      description: 'Explore the masterpieces of English literature from Shakespeare to contemporary authors. Develop critical thinking and analytical skills through literary analysis.',
      icon: pic5,
    },
    {
      id: 6,
      name: 'Sanskrit Literature',
      description: 'Discover the ancient wisdom of Sanskrit texts and classical literature. Study the language, philosophy, and cultural heritage preserved in this scholarly tradition.',
      icon: pic6,
    },
    {
      id: 7,
      name: 'Sociology',
      description: 'Study human society, social institutions, and cultural patterns. Examine how societies are organized and how people interact within social structures.',
      icon: pic7,
    },
    {
      id: 8,
      name: 'History',
      description: 'Trace the evolution of human civilization through time. Understand the events, people, and forces that have shaped our world from ancient times to the present.',
      icon: pic8,
    },
    {
      id: 9,
      name: 'Mathematics',
      description: 'Master advanced mathematical concepts and problem-solving techniques. Study calculus, algebra, and statistics to understand patterns and relationships.',
      icon: pic9,
    },
    {
      id: 10,
      name: 'Computer Science',
      description: 'Enter the digital world through programming and computational thinking. Learn coding, algorithms, and data structures for the modern technological age.',
      icon: pic10,
    },
    {
      id: 11,
      name: 'Punjabi Literature',
      description: 'Celebrate the vibrant literary heritage of Punjab. Read works that capture the spirit, culture, and traditions of Punjabi people and their profound contributions.',
      icon: pic11,
    }
  ];

  // Auto-play slider
  useEffect(() => {
    if (!autoPlay) return;
    
    const interval = setInterval(() => {
      setCurrentImageSlide((prev) => (prev + 1) % sliderImages.length);
    }, 5000);

    return () => clearInterval(interval);
  }, [autoPlay, sliderImages.length]);

  const nextSlide = () => {
    setAutoPlay(false);
    setCurrentImageSlide((prev) => (prev + 1) % sliderImages.length);
    setTimeout(() => setAutoPlay(true), 5000);
  };

  const prevSlide = () => {
    setAutoPlay(false);
    setCurrentImageSlide((prev) => (prev - 1 + sliderImages.length) % sliderImages.length);
    setTimeout(() => setAutoPlay(true), 5000);
  };

  const goToImageSlide = (index) => {
    setAutoPlay(false);
    setCurrentImageSlide(index);
    setTimeout(() => setAutoPlay(true), 5000);
  };

  return (
    <>
      {/* Arts Banner */}
      <div className="ac-banner-section">
        <div className="ac-banner-overlay"></div>
        <div className="ac-banner-content">
          <h1 className="ac-banner-title">ARTS STREAM</h1>
        </div>
      </div>

      {/* Main Arts Section */}
      <section className="ac-main-section" id="ac-arts-main">
        {/* About & Slider Container - Side by Side */}
        <div className="ac-about-slider-container">
          {/* Left - About Section */}
          <div className="ac-about-wrapper">
            <div className="ac-description-block">
              <h2 className="ac-section-title">About <span className="ac-title-highlight">Arts Stream</span></h2>
              <p className="ac-description-text">
                The Arts stream offers a comprehensive exploration of human knowledge, culture, society, and history. 
                Our curriculum develops critical thinking, analytical skills, and creative expression through the study of 
                humanities and social sciences. Students gain deep insights into how societies function, how cultures evolve, 
                and how to engage meaningfully with the world around them.
              </p>
            </div>
          </div>

          {/* Right - Image Slider */}
          <div className="ac-slider-wrapper">
            <div className="ac-image-carousel">
              {/* Image Display */}
              <div className="ac-image-display">
                {sliderImages.map((image, index) => (
                  <div 
                    key={index}
                    className={`ac-image-item ${index === currentImageSlide ? 'ac-image-active' : ''}`}
                  >
                    <img src={image} alt={`Arts ${index + 1}`} />
                  </div>
                ))}
              </div>

              {/* Navigation Arrows */}
              <button 
                className="ac-image-nav-btn ac-image-nav-prev"
                onClick={prevSlide}
                aria-label="Previous image"
              >
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <polyline points="15 18 9 12 15 6"></polyline>
                </svg>
              </button>

              <button 
                className="ac-image-nav-btn ac-image-nav-next"
                onClick={nextSlide}
                aria-label="Next image"
              >
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <polyline points="9 18 15 12 9 6"></polyline>
                </svg>
              </button>
            </div>
          </div>
        </div>

        {/* Arts Subjects Section */}
        <div className="ac-content-section">

          <div className="ac-subjects-container">
            <h3 className="ac-subjects-heading">Our <span className="ac-heading-accent">Subjects</span></h3>
            
            <div className="ac-subjects-grid">
              {subjects.map((subject) => (
                <div 
                  key={subject.id} 
                  className="ac-subject-card"
                >
                  <div className="cc-card-icon">
                    <img src={subject.icon} alt={subject.name}  className="lab-item-iconcc"/>
                  </div>
                  <h4 className="ac-card-title">{subject.name}</h4>
                  <p className="ac-card-desc">{subject.description.substring(0, 80)}...</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
export default ArtsCategory;